<template>
  <div v-if="!showInfoUpdateForm">
    <vx-card>
      <div class="flex" style="align-items: start">
        <vs-row>
          <vs-col class="mb-6 flex" vs-align="center">
            <h5 style="height: 21px"><i class="dot"></i>개인정보변경</h5>
          </vs-col>
          <vs-col>
            <vs-row class="flex justify-between mb-4" vs-align="center">
              <h5 class="vx-col sm:w-3/12 mb-2 sm:mb-2">현재 비밀번호</h5>
              <div class="vx-col w-full sm:w-9/12 flex gap-4">
                <vs-input class="flex-1" type="password" :max="150" placeholder="" v-model="loginPassword" @keyup.enter="checkPassword" />
                <vs-button class="" color="secondary" @click="checkPassword">확인</vs-button>
              </div>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vx-card>
  </div>

  <vs-card v-else-if="userData">
    <div class="p-4">
      <div class="flex flex-col md:flex-row flex-wrap gap-4">
        <span style="font-weight: 700; font-size: 18px">개인정보변경</span>
        <div class="md:ml-auto flex flex-col md:flex-row items-center gap-3">
          <vs-button class="w-full md:w-auto" color="secondary" type="border" @click="onClickClose">취소</vs-button>
          <vs-button class="w-full md:w-auto" color="secondary" @click="handleUserInfoModified">변경사항 저장</vs-button>
        </div>
      </div>

      <h5 class="my-4"><i class="dot"></i> 작업자 정보</h5>
      <div class="grid-container">
        <!-- 일용직 회원의 경우 업체검색 폼이 나타나지 않도록 함 -->
        <input-form v-if="userData.meta.registerType !== 일용직.value" class="grid-item" label="업체명">
          <div class="align-center" style="display: grid; grid-template-columns: 1fr; gap: 0.675rem">
            <ml-input class="w-full" :value="userData.company && userData.company.com_name ? userData.company.com_name : ''" readonly />
          </div>
        </input-form>
      </div>

      <div class="grid-container mt-4">
        <input-form class="grid-item" label="아이디">
          <label class="w-full" style="gap: 0.675rem">
            <ml-input class="w-full" placeholder="아이디 입력" :value="userData.username ? userData.username : ''" readonly />
          </label>
        </input-form>
        <input-form class="grid-item" label="비밀번호">
          <div class="align-center" style="display: grid; grid-template-columns: 1fr auto auto; gap: 0.675rem">
            <ml-input class="w-full" type="password" placeholder="********" v-model="userData.password" :readonly="!modeChangePassword"/>
            <vs-button v-if="!modeChangePassword" class="px-3" color="secondary" tabindex="-1" @click="changePassword">변경</vs-button>
            <vs-button v-else class="px-3" color="secondary" type="border" tabindex="-1" @click="cancelPassword">취소</vs-button>
            <vs-button class="px-3" color="secondary" type="border" tabindex="-1" @click="resetPassword">비밀번호 초기화(ID와 동일)</vs-button>
          </div>
        </input-form>
        <template v-if="modeChangePassword" >
          <div></div>
          <input-form class="grid-item" label="비밀번호 확인">
            <div class="align-center" >
              <ml-input class="w-full" type="password" placeholder="********" v-model="userData.password_confirmation"/>
            </div>
          </input-form>
        </template>

        <input-form class="grid-item gap-2" label="내국인/외국인">
          <radio-group
            class="col-span-4 my-2"
            flex
            :items="[
              { label: '내국인', value: false },
              { label: '외국인', value: true },
            ]"
            :row-count="2"
            v-model="userData.meta.is_foreigner"
          />
        </input-form>
      </div>

      <div class="grid-container mt-4">
        <input-form class="grid-item" label="이름">
          <ml-input class="w-full" v-model="userData.name" />
        </input-form>
        <input-form class="grid-item" :label="userData.meta.is_foreigner ? '외국인등록번호(앞 7자리 한정)' : '주민등록번호(앞 7자리 한정)'">
          <div class="flex items-center">
            <HyphenInput v-model="userData.meta.rrn" :setting="[{ max: 6 }, { max: 1, style: 'flex:none !important; width:30px' }]" style="flex: 1.5" />
            <p style="flex: 1; padding: 4px 8px 0; letter-spacing: 2px">******</p>
          </div>
        </input-form>

        <input-form class="grid-item" label="휴대폰번호" :is-success="!!alertMsg.succPhone" :success-message="alertMsg.succPhone ? alertMsg.succPhone : ''" :errorMessage="alertMsg.errPhone ? alertMsg.errPhone : ''">
          <div v-if="!isChangePhoneNumber" class="flex gap-2">
            <HyphenInput v-model="userData.phone" readonly class="flex-1" />
            <vs-button style="width: 80px; padding: 0" color="secondary" type="border" @click="isChangePhoneNumber = true">번호변경</vs-button>
          </div>
          <div v-else>
            <div class="flex gap-2">
              <HyphenInput v-model="tempPhoneNumber" class="flex-1" />
              <vs-button style="width: 110px; padding: 0" color="secondary" type="border" @click="onClickGetPhoneAuth">인증번호 전송</vs-button>
              <vs-button style="width: 80px; color: #3c3c3c; padding: 0" color="#DCDFE2" @click="cancelChangePhoneNumber">변경취소</vs-button>
            </div>
            <div class="flex gap-2 mt-3">
              <ml-input v-model="phoneAuth" class="flex-1" />
              <vs-button style="width: 80px; padding: 0" color="secondary" type="border" @click="onClickCheckPhoneAuth">인증확인</vs-button>
            </div>
          </div>
        </input-form>
        <input-form class="grid-item" label="이메일">
          <div class="flex gap-2">
            <ml-input class="w-full" v-model="userData.email" />
            <!-- <vs-button style="width: 80px; padding: 0" color="secondary" type="border" @click="onClickClose">메일변경</vs-button> -->
          </div>
        </input-form>
      </div>

      <div class="grid-container mt-4">
        <input-form class="grid-item" label="직책">
          <ml-input class="w-full" v-model="userData.rank" />
        </input-form>
        <input-form class="grid-item" label="직종">
          <ml-input class="w-full" v-model="userData.position" />
        </input-form>
      </div>

      <div class="grid-container mt-4">
        <input-form class="grid-item" label="건설업기초안전교육">
          <file-uploader :readonly="false" class="w-full" v-model="userData.meta.건설업기초안전교육" />
        </input-form>
        <input-form class="grid-item" label="교육 이수번호">
          <ml-input class="w-full" v-model="userData.meta.교육이수번호" />
        </input-form>
        <input-form class="col-span-2 md:col-span-1" label="서명 등록">
          <radio-group
            class="my-4"
            v-model="signUploadType"
            flex
            :items="[
              { label: '서명 이미지 업로드', value: 'image' },
              { label: '서명 직접그리기', value: 'draw' },
            ]"
          />
          <div class="grid gap-2 mb-2">
            <div v-if="signUploadType === 'image'">
              <div class="mb-2" style="max-width: 492px; height: 180px">
                <file-uploader v-model="signImage" id="imageSign" type="only-image" />
              </div>
              <p class="flex items-center gap-2 mb-2">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_25958_315609)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10 2.5026C5.85791 2.5026 2.50004 5.86047 2.50004 10.0026C2.50004 14.1447 5.85791 17.5026 10 17.5026C14.1422 17.5026 17.5 14.1447 17.5 10.0026C17.5 5.86047 14.1422 2.5026 10 2.5026ZM0.833374 10.0026C0.833374 4.93999 4.93743 0.835938 10 0.835938C15.0627 0.835938 19.1667 4.93999 19.1667 10.0026C19.1667 15.0652 15.0627 19.1693 10 19.1693C4.93743 19.1693 0.833374 15.0652 0.833374 10.0026ZM10.2152 6.69001C9.8273 6.62347 9.42834 6.69637 9.089 6.8958C8.74967 7.09523 8.49186 7.40832 8.36125 7.77962C8.20852 8.21377 7.73276 8.44192 7.2986 8.28919C6.86444 8.13647 6.6363 7.6607 6.78903 7.22654C7.05025 6.48395 7.56586 5.85777 8.24453 5.45891C8.9232 5.06005 9.72113 4.91425 10.497 5.04734C11.2729 5.18042 11.9766 5.58379 12.4836 6.18602C12.9904 6.78812 13.2679 7.55015 13.2668 8.33717C13.2664 9.61247 12.3209 10.4547 11.6457 10.9048C11.2827 11.1468 10.9256 11.3248 10.6625 11.4417C10.5298 11.5007 10.4181 11.5454 10.3376 11.5761C10.2972 11.5915 10.2645 11.6034 10.2407 11.6118L10.2118 11.622L10.2026 11.6251L10.1993 11.6262L10.198 11.6266C10.1978 11.6267 10.197 11.627 9.93347 10.8364L10.197 11.627C9.76037 11.7725 9.28844 11.5366 9.1429 11.0999C8.99746 10.6636 9.23301 10.192 9.66908 10.0461L9.68237 10.0415C9.69519 10.0369 9.7162 10.0293 9.74423 10.0186C9.80042 9.9972 9.88398 9.96384 9.98565 9.91865C10.1913 9.82723 10.4592 9.69269 10.7212 9.51804C11.2959 9.13493 11.6001 8.72736 11.6001 8.33641L11.6001 8.33517C11.6007 7.94157 11.462 7.56047 11.2085 7.25935C10.955 6.95824 10.6032 6.75655 10.2152 6.69001ZM10 13.3359C9.5398 13.3359 9.16671 13.709 9.16671 14.1693C9.16671 14.6295 9.5398 15.0026 10 15.0026H10.0084C10.4686 15.0026 10.8417 14.6295 10.8417 14.1693C10.8417 13.709 10.4686 13.3359 10.0084 13.3359H10Z"
                      fill="#3C3C3C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_25958_315609">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                흰 배경(A4용지 등)에 직접 서명하여 찍은 사진을 기기(PC, 태블릿 등)에 저장하여 업로드 합니다.
              </p>
              <p class="flex items-center gap-2" style="color: #ea5455">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 8.99749C0 4.03068 4.02707 0 9 0C13.9729 0 18 4.03068 18 8.99749C18 13.9643 13.9729 17.995 9 17.995C4.02707 17.995 0 13.9643 0 8.99749ZM9 1.99499C5.13637 1.99499 2 5.12776 2 8.99749C2 12.8672 5.13637 16 9 16C12.8636 16 16 12.8672 16 8.99749C16 5.12776 12.8636 1.99499 9 1.99499Z"
                    fill="#EA5455"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 2.55469C9.62132 2.55469 10.125 3.05696 10.125 3.67656V9.2859C10.125 9.90549 9.62132 10.4078 9 10.4078C8.37868 10.4078 7.875 9.90549 7.875 9.2859V3.67656C7.875 3.05696 8.37868 2.55469 9 2.55469Z"
                    fill="#EA5455"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 11.5313C9.62132 11.5313 10.125 12.0335 10.125 12.6531L10.125 13.775C10.125 14.3946 9.62132 14.8969 9 14.8969C8.37868 14.8969 7.875 14.3946 7.875 13.775L7.875 12.6531C7.875 12.0335 8.37868 11.5313 9 11.5313Z"
                    fill="#EA5455"
                  />
                </svg>
                1MB 이하의 이미지형식(JPG, PNG 등) 파일만 업로드 가능합니다)
              </p>
            </div>
            <div v-if="signUploadType === 'draw'" style="max-width: 300px">
              <sign-field class="py-2" max-width="300px" :useLoadSign="false" v-model="userData.meta.서명" />
            </div>
          </div>
          <p style="font-size: 14px; font-weight: 400; color: #4839EB">※ 본인 고유의 필체로 자신의 이름을 제 3자가 알아볼 수 있도록 정자로 서명등록 부탁드립니다.(이름 확인이 안될 시 반려될 수 있습니다.)</p>
        </input-form>
        <input-form class="col-span-2 md:col-span-1" label="신분증 사진">
          <div class="relative mb-2" style="width: 120px; height: 120px">
            <image-to-base64-form class="w-full" label="사진" v-model="userData.meta.신분증사진">
              <div>
                <img :src="require('@/assets/images/_bs/Union.png')" />
                <div class="absolute" style="bottom: 0; right: 4px">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                      fill="#EA5455"
                    />
                  </svg>
                </div>
              </div>
            </image-to-base64-form>
          </div>
          <p style="font-size: 14px; font-weight: 400; color: #4839EB">※ 주민등록번호 뒷자리는 가려서 촬영해주세요.</p>
        </input-form>
      </div>

      <h5 class="my-8 flex gap-2"><vs-checkbox v-model="userData.meta.장비운전자" /> 장비운전자</h5>
      <div v-if="userData.meta.장비운전자" class="grid-container mt-4">
        <div class="grid-item">
          <span>건설기계 조종사 면허</span>
          <ml-input class="my-1 w-full" v-model="userData.meta.건설기계조종사면허번호" />
        </div>

        <input-form class="col-span-2 md:col-span-1" label="면허증 사진">
          <div class="relative mb-2" style="width: 120px; height: 120px">
            <image-to-base64-form class="w-full" label="사진" v-model="userData.meta.건설기계조종사면허증사진">
              <div>
                <img :src="require('@/assets/images/_bs/Union.png')" />
                <div class="absolute" style="bottom: 0; right: 4px">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                      fill="#EA5455"
                    />
                  </svg>
                </div>
              </div>
            </image-to-base64-form>
          </div>
          <p style="font-size: 14px; font-weight: 400; color: red">※ 주민등록번호 뒷자리는 가려서 촬영해주세요.</p>
        </input-form>
      </div>
    </div>
  </vs-card>
</template>

<script>
import { VueDaumPostcode } from "vue-daum-postcode";
import DateSelector from "@/components/selector/DateSelector";
import FileUploader from "@/components/FileUploader.vue";
import VueCookie from "vue-cookie";
import config from "/public/config";
import HttpRequest from "@/util/HttpRequest";

import InputForm from "@/views/pages/register/InputForm.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import SignField from "@/components/SignField.vue";
import ImageToBase64Form from "@/components/ImageToBase64Form.vue";

import { getRegisterTypeInfo, registerTypeList } from "@/views/pages/register/RegisterTypeInfo.js";

export default {
  name: "MyPageInfoUpdate",
  components: {
    FileUploader,
    DateSelector,
    VueDaumPostcode,
    InputForm,
    RadioGroup,
    SignField,
    ImageToBase64Form,
  },

  data() {
    return {
      //  ========= PAGE 1 ===============
      showInfoUpdateForm: false,
      loginPassword: "",

      //  ========= PAGE 2 ===============
      // 비밀번호 변경 여부
      modeChangePassword: false,
      // 비밀번호 초기화 시도
      modeResetPassword: false,

      userData: null,

      // 사업장명 리스트트
      fieldOptions: [],
      // 업체명(사업자등록번호) 변경
      isChangeCompany: false,
      tempCompanyCode: "",
      // 휴대폰번호 변경
      isChangePhoneNumber: false,
      tempPhoneNumber: "",
      isShowPhoneAuth: false,
      phoneAuth: "",

      일용직: getRegisterTypeInfo("일용직"),

      // 서명
      signUploadType: "image",
      signImage: undefined,
      oldSignImage: undefined,

      alertMsg: {
        errPhone: "",
        succPhone: "",
      },
    };
  },
  computed: {
    formatRRN() {
      const rrn = `${this.userData.meta.rrn}`.replaceAll("-", "");

      if (!rrn || rrn.length !== 7 || isNaN(rrn)) return "";

      const datePart = rrn.slice(0, 6);
      const lastDigit = rrn[6];

      return `${datePart}-${lastDigit}******`;
    },

    // 비밀번호 유효성 검사 (return 에러문구)
    validatePassword() {
      // this.userData.password_old 가 존재하지 않으면 비밀번호 변경이 아님
      // [변경], [비밀번호 초기화(ID와 동일)] 버튼이 클릭했을 경우, this.userData.password_old 에 값을 넣어줌
      if (!this.userData.password_old) {
        return false;
      }

      if (this.userData.password === '') {
        return '비밀번호를 입력해주세요';
      }

      if (this.userData.password !== this.userData.password_confirmation) {
        return '비밀번호가 일치하지 않습니다';
      }

      // 초기화 버튼을 눌렀을 경우에는 비밀번호 유효성 검사를 하지 않음
      if (!this.modeResetPassword) {
        //const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,16}$/;
        const regex = /^\S{8,16}$/; // 공백을 제외한 8~16자
        if (!regex.test(this.userData.password)) {
          return '비밀번호는 공백을 제외한 8~16자를 입력해주세요';
        }
      }

      return false;
    },

    // 서명의 변경 여부를 반환
    changedSign() {
      const oldPath = this.oldSignImage && this.oldSignImage.path;
      if (this.signUploadType === "image") {
        if (this.signImage.path !== oldPath) {
          return true;
        }
      }

      if (this.signUploadType === "draw") {
        if (this.userData.meta.서명 !== oldPath) {
          return true;
        }
      }
      return false;
    },
  },
  created() {
    this.loadMember();
    this.loadFieldList();
  },
  methods: {
    checkPassword() {
      const password = this.loginPassword;

      if (!password) {
        this.errorAlert("비밀번호를 입력해주세요");
        return;
      }

      HttpRequest.post("/api/auth/check", { password })
        .then((response) => {
          this.showInfoUpdateForm = true;

          this.$nextTick(async () => {
            await this.$store.dispatch("USER_INFO");
            await this.loadInfoWorkPosition();
            await this.loadMember();
          });
        })
        .catch((err) => {
          // CORS 에러나 네트워크 에러로 response가 없는 경우
          if (!err.response) {
            this.errorAlert("네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
            return;
          }

          const message = typeof err.response.data === "object" ? err.response.data.password[0] : err.response.data;
          switch (message) {
          case "The password must be between 8 and 255 characters.":
            this.errorAlert("비밀번호는 8자 이상 255자 이하로 입력해주세요");
            break;
          default:
            this.errorAlert(message);
            break;
          }
        });
    },

    // 서명 불러오기
    loadSign() {
      const options = {
        name: "",
      };
      this.$store
        .dispatch("member/LOAD_SIGNATURE", options)
        .then((signList) => {
          let defaultSign = undefined;
          for (let i = 0; i < signList.length; i++) {
            if (signList[i].is_default) {
              defaultSign = signList[i];
              break;
            }
          }
          if (defaultSign) {
            this.signImage = {
              id: defaultSign.file_id,
              fileName: defaultSign.file.file_name,
              fileSize: defaultSign.file.file_size,
              path: defaultSign.file.path,
              thumb: defaultSign.file.path,
              signId: defaultSign.id,
            };
            this.oldSignImage = JSON.parse(JSON.stringify(this.signImage));
          }
        })
        .catch((error) => {
          const customAlert = new CustomEvent("customAlert", {
            detail: {
              title: "에러",
              message: error,
            },
          });
          window.dispatchEvent(customAlert);
        });
    },

    // 회원정보 불러오기
    async loadMember() {
      await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");

      // 수정된 부분을 체크하기위해 깊은복사를 한다.
      const member = Object.assign({}, this.$store.state.member.memberInfo);
      const meta = this.transformToMeta(member.metas);
      delete member.metas;

      const metaDefault = {
        field: {
          id: 0,
          field_name: "",
        },
        직종: "",
        직책: "",
        address: {
          home_zip: "",
          home_address_1: "",
          home_address_2: "",
        },
        registerType: "",
        담당부서: "",
        장비운전자: "",
        교육이수번호: "",
        건설업기초안전교육: {},
        건설기계조종사면허번호: "",
        신분증사진: "",
        건설기계조종사면허증사진: "",
        rrn: "",
        is_foreigner: "",
        country: "",
        서명: "",
      };

      const userData = {
        ...member,
        oldEmail: member.email,
        meta: {
          ...metaDefault,
          ...meta,
        },
      };

      userData.meta.rrn = `${userData.meta.rrn}`;

      this.userData = userData;

      // 서명 불러오기
      this.loadSign();
    },

    transformToMeta(metas) {
      const meta = {};

      metas.forEach(({ meta_key, meta_value }) => {
        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },

    // ============ 사업장명 검색 =============
    async loadFieldList() {
      await HttpRequest.get("/api/v1/field/pub")
        .then((response) => {
          if (response) {
            this.fieldOptions = response[0].fields.map((data) => {
              return {
                id: data.id,
                field_name: data.field_name,
              };
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    changeFieldData(data) {
      this.userData.meta.field.field_name = this.fieldOptions.find((_fo) => _fo.id === data).field_name;
    },

    // =========== 업체(사업자등록번호) 검색 ============
    cancelFindCompany() {
      this.isChangeCompany = false;
      this.tempCompanyCode = "";
    },
    async onClickFindCompany() {
      if (!this.tempCompanyCode) {
        return;
      }

      await HttpRequest.get("/api/v1/company/pub", {
        params: { bnum: this.tempCompanyCode },
      }).then((response) => {
        if (response) {
          if (response && response.data && response.data.length > 0) {
            this.userData.meta.업체 = response.data[0];
            this.isChangeCompany = false;
          } else {
            this.errorAlert("업체를 찾을 수 없습니다.");
          }
        }
      });
    },
    // ====================== 비밀번호 변경 클릭 ===========================

    changePassword() {
      this.modeChangePassword = true
      this.modeResetPassword = false;
      this.userData.password_old = this.loginPassword;
    },

    // ====================== 비밀번호 변경취소 ===========================

    cancelPassword () {
      this.modeChangePassword = false;
      this.modeResetPassword = false;
      this.userData.password_old = "";
      this.userData.password = "";
      this.userData.password_confirmation = "";
    },

    // ====================== 비밀번호 초기화 ===========================

    resetPassword() {
      this.modeChangePassword = true;
      this.modeResetPassword = true;
      this.userData.password_old = this.loginPassword;
      this.userData.password = this.userData.username;
      this.userData.password_confirmation = this.userData.username;
    },

    // ====================== 휴대폰번호 ===========================
    cancelChangePhoneNumber() {
      this.isChangePhoneNumber = false;
      this.tempPhoneNumber = "";
      this.isShowPhoneAuth = false;
      this.phoneAuth = "";
    },

    // 핸드폰 인증번호 발송
    async onClickGetPhoneAuth() {
      if (!this.tempPhoneNumber) return;

      await HttpRequest.post("/api/v1/user/verification/sms", {
        phone: this.tempPhoneNumber,
      })
        .then((response) => {
          if (response) {
            this.alertMsg.errPhone = "";
            this.alertMsg.succPhone = "인증번호가 발송되었습니다.";
            this.isShowPhoneAuth = true;
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("err", err, err.response);
            if (err.response.data) {
              this.alertMsg.errPhone = err.response.data.message;
            }
          }
        });
    },
    // 핸드폰 인증번호 확인
    async onClickCheckPhoneAuth() {
      await HttpRequest.post("/api/v1/user/verification/sms/confirm", {
        phone: this.tempPhoneNumber,
        code: this.phoneAuth,
      })
        .then((response) => {
          this.alertMsg.errPhone = "";
          this.alertMsg.succPhone = "인증이 완료되었습니다.";
          this.userData.phone = this.tempPhoneNumber;
          this.cancelChangePhoneNumber();
        })
        .catch((err) => {
          this.alertMsg.succPhone = "";
          if (err.response && err.response.data) {
            // 기존에 인증된 상태
            if (err.response.status === 409) this.alertMsg.errPhone = err.response.data.message;
            else this.alertMsg.errPhone = err.response.data.message;
          }
        });
    },

    // ======================================

    // vs-upload에 초기 이미지 넣기
    async setVsUploadImage(_t, src, uploadedFileId) {
      let orientation = "h";
      const image = new Image();
      image.src = src;
      image.onload = function () {
        if (this.width > this.height) {
          orientation = "w";
        }

        const obj = {
          uploadedFileId,
          src: this.src,
          orientation,
          type: "image",
          percent: null,
          error: false,
          remove: false,
        };

        _t.$refs.vs_upload_1.srcs = [JSON.parse(JSON.stringify(obj))];
        _t.$refs.vs_upload_1.filesx = [JSON.parse(JSON.stringify(obj))];
      };
    },
    async loadInfoWorkPosition() {
      await this.$store.dispatch("project/HSE_LOAD_INFO_WORKPOSITION");
      const list = this.$store.state.project.hseInfoWorkPositionList;

      this.workPosition = [];
      for (const item of list) {
        this.workPosition.push({ text: item.name, value: item.id });
      }
    },

    async handleUserInfoModified() {
      const metas = this.transformToMetas({ ...this.userData.meta, rrn: this.userData.meta.rrn ? `${this.userData.meta.rrn}`.replaceAll("-", "") : "" });
      const form = {
        userId: this.userData.id,
        rank: this.userData.rank,
        position: this.userData.position,
        metas
      };

      if (this.userData.name) form.name = this.userData.name;
      if (this.userData.email && this.userData.email !== this.userData.oldEmail) form.email = this.userData.email;
      if (this.userData.phone) form.phone = this.userData.phone;

      if (this.userData.password_old) form.password_old = this.userData.password_old;
      if (this.userData.password) form.password = this.userData.password;
      if (this.userData.password_confirmation) form.password_confirmation = this.userData.password_confirmation;

      const error = this.validatePassword
      if (error) {
        this.errorAlert(error);
        return;
      }

      // 서명 저장
      if (this.changedSign) {
        if (this.signUploadType === "image" && (!this.signImage || !this.signImage.path)) {
          // 서명 삭제
          const deleteSign = await this.deleteSign();
          if (!deleteSign) {
            return;
          }
        } else if (this.signUploadType === "draw" && !this.userData.meta.서명) {
          // 서명 삭제
          const deleteSign = await this.deleteSign();
          if (!deleteSign) {
            return;
          }
        } else {
          const uploadSign = await this.uploadSign();
          if (!uploadSign) {
            return;
          }
        }
      }

      this.$store
        .dispatch("member/MODIFY_MEMBER", form)
        .then(async (/*value*/) => {
          // 회원정보의 중복 호출을 막기위해 localStorage 에 값이 있을 경우, 변경되지 않으므로,
          // Storage 에 저장된 회원정보를 삭제한다.
          localStorage.removeItem("/api/auth/me");
          await this.$store.dispatch("USER_INFO");

          this.userData.oldEmail = this.userData.email;

          alert("저장 되었습니다");

          // 저장 후 페이지 리로드
          this.$nextTick(() => {
            this.$router.go(0);
          });
        })
        .catch((err) => {
          // CORS 에러나 네트워크 에러로 response가 없는 경우
          if (!err.response) {
            if (err.code === 'ERR_NETWORK' || err.message.includes('CORS')) {
              this.errorAlert("네트워크 연결 오류가 발생했습니다. CORS 정책으로 인해 요청이 차단되었을 수 있습니다.");
            } else {
              this.errorAlert("네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
            }
            return;
          }

          const code = err.response.status;
          switch (code) {
          case 400:
            this.errorAlert(err.response.data);
            break;
          case 404:
            this.errorAlert("대상 사용자를 찾을 수 없습니다.");
            break;
          case 403:
            this.errorAlert("회원 정보 변경 권한이 없습니다");
            break;
          case 499:
            if (err.response.data.password_old) {
              this.errPasswordOld = typeof err.response.data.password_old === "object" ? this.errorKo(err.response.data.password_old[0]) : this.errorKo(err.response.data.password_old);
            }
            if (err.response.data.password) {
              this.errPassword = typeof err.response.data.password === "object" ? this.errorKo(err.response.data.password[0]) : this.errorKo(err.response.data.password);
            }
            if (err.response.data.password_confirmation) {
              this.errPasswordConfirm = typeof err.response.data.password_confirmation === "object" ? this.errorKo(err.response.data.password_confirmation[0]) : this.errorKo(err.response.data.password_confirmation);
            }
            break;
          default:
            this.errorAlert(this.errorKo(err.response.data));
            break;
          }
        });
    },

    transformToMetas(meta, parentKey = "") {
      const metas = [];

      for (const [key, value] of Object.entries(meta)) {
        const fullKey = parentKey ? `${parentKey}.${key}` : `${key}`;

        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
          metas.push(...this.transformToMetas(value, fullKey.replace(/^metas\.key\./, "")));
        } else {
          metas.push({
            key: fullKey,
            value: `${value}`,
          });
        }
      }

      return metas;
    },

    handlePostcodeComplete(data) {
      // 도로명(R), 지번(J)
      const userSelectedType = data.userSelectedType;

      // 우편번호
      const zonecode = data.zonecode;

      // 주소
      let address1 = data.roadAddress;
      if (userSelectedType === "J") {
        address1 = data.jibunAddress;
      }

      // 자택주소
      if (this.postcode.active) {
        this.form.home_zip = zonecode;
        this.form.home_address_1 = address1;
      }

      this.postcode.active = false;
    },

    handleChangeFile(path, files) {
      this.fileNum = typeof this.fileNum === "number" ? this.fileNum + 1 : 0;
    },

    errorAlert(message) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "오류가 발생했습니다",
          message,
        },
      });
      window.dispatchEvent(customAlert);
    },
    errorKo(errMsg) {
      switch (errMsg) {
      case "The password format is invalid.":
        return "대문자, 소문자, 숫자를 포함하여 8자 이상 255자 이하로 입력해주세요.";
      case "The password old must be between 4 and 255 characters.":
      case "The password must be between 8 and 255 characters.":
      case "The password confirmation must be between 8 and 255 characters.":
        return "8자 이상 255자 이하로 입력해주세요";
      case "The password confirmation field is required when password is present.":
        return "비밀번호 확인을 입력해주세요";
      case "The avatar must be an image.":
        return "이미지 파일만 업로드 가능합니다";
      default:
        return errMsg;
      }
    },

    onClickClose() {
      window.location.reload();
    },

    async uploadSign() {
      if (this.signUploadType === "image" && this.signImage && this.signImage.id) {
        return await this._uploadSign(this.signImage);
      } else if (this.signUploadType === "draw" && this.userData.meta.서명) {
        return await this.file_upload_blob(this.userData.meta.서명)
          .then((file) => {
            return this._uploadSign(file);
          })
          .catch((error) => {
            const customAlert = new CustomEvent("customAlert", {
              detail: {
                title: "에러",
                message: error,
              },
            });
            window.dispatchEvent(customAlert);
          });
      }


    },
    async deleteSign() {
      if (this.oldSignImage && this.oldSignImage.signId) {
        return await this.$store
          .dispatch("member/DELETE_SIGNATURE", {
            signatureId: this.oldSignImage.signId,
          })
          .then((message) => {
            this.userData.meta.서명 = "";
            return true;
          })
          .catch((err) => {
            console.log("error", err.response);
            const customAlert = new CustomEvent("customAlert", {
              detail: {
                title: "에러",
                message: err,
              },
            });
            window.dispatchEvent(customAlert);
            return false;
          });
      }
    },
    async _uploadSign(file) {
      return await this.$store
        .dispatch("member/CREATE_SIGNATURE", {
          description: "",
          fileId: file.id,
          makeDefault: true,
          removeAll: true,
        })
        .then((message) => {
          return true;
          // const customAlert = new CustomEvent("customAlert", {
          //   detail: {
          //     title: "알림",
          //     message: message,
          //   },
          // });
          // window.dispatchEvent(customAlert);
        })
        .catch((error) => {
          const customAlert = new CustomEvent("customAlert", {
            detail: {
              title: "에러",
              message: error,
            },
          });
          window.dispatchEvent(customAlert);
          return false;
        });
    },
    async file_upload_blob(dataURL) {
      const blobBin = atob(dataURL.split(",")[1]);
      const array = [];
      for (let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }
      const date = new Date().getTime();
      const file = new File([new Uint8Array(array)], `서명_${date}.png`, { type: "image/png" });

      await this.$store.dispatch("file/FILE_UPLOAD", file);
      return this.$store.state.file.uploadedFile;
    },
  },
};
</script>

<style>
#postcodePopup .vue-daum-postcode-container {
  height: 450px !important;
}

[dir] .con-input-upload {
  margin: 0;
}
[dir] .con-img-upload {
  padding: 0;
}
</style>

<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    background-color: #f5f5f5;
    font-weight: 700;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-body {
    background-color: #ffffff;
    & > div {
      border-bottom: 1px solid #e0e0e0;
    }
    & > div:hover {
      background-color: #f5f5f5;
      color: #000;
      font-weight: bold;
    }
    & > div.active {
      background-color: #7e72f299;
      color: #fff;
    }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(10, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}

.align-center {
  align-items: center;
}
.success-color {
  color: #28c76f;
}
.alert-color {
  color: #ea5455;
}
.input-button {
  height: 37.5px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}

.grid-item {
  align-self: start;
  grid-column: span 2;
}

@media (min-width: 768px) {
  .grid-item {
    align-self: start;
    grid-column: span 1;
  }
}
</style>
